module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<fieldset><legend>'+
((__t=( i18n.tc("InsuranceCompanySelection", "Select an insurance company") ))==null?'':__t)+
'</legend><div class="double-column" data-region="selection-container"></div> ';
 if ( yearlyService ) { 
__p+=' <div class="long-line"><input type="checkbox" id="selection-service-input" data-input="selection-service" value="yearly"> <label class="align-left no-ellipsis" for="selection-service-input">'+
((__t=( i18n.tc("InsuranceCompanySelection", "Insurance company demands yearly service at certified installer.") ))==null?'':__t)+
'</label></div> ';
 } 
__p+=' </fieldset><fieldset class="button-wrap"><button data-click="selection-cancel">'+
((__t=( i18n.tc("InsuranceCompanySelection", "Cancel") ))==null?'':__t)+
'</button> <button class="primary" data-click="selection-submit" disabled="disabled">'+
((__t=( i18n.tc("InsuranceCompanySelection", "Next") ))==null?'':__t)+
'</button></fieldset>';
}
return __p;
};
